import React, { useState, useRef, useEffect } from "react";
import { FiPlus } from "react-icons/fi";

import "./faq_style.css";

function Section(props) {
    const [active, setActive] = useState(false);
  
    const contentRef = useRef(null);
  
    useEffect(() => {
      contentRef.current.style.maxHeight = active
        ? `${contentRef.current.scrollHeight}px`
        : "0px";
    }, [contentRef, active]);
  
    const toggleAccordion = () => {
      setActive(!active);
    };

    return(
    <div className="text-center p-1 align-middle ">
      <button
        className={` question-section p-3 w-[90vw] sm:w-[85vw] ${active}`}
        onClick={toggleAccordion}
      >
        <div>
          <div className="question-align text-[18px] 2xs:text-[22px]">
            <h4 className="question-style">
              {props.title}
            </h4>
            <FiPlus
              className={active ? `question-icon hidden 2xs:block rotate text-[20px] sm:text-[30px] md:text[40px]` : `question-icon hidden 2xs:block text-[20px] sm:text-[30px] md:text-[40px]`}
            />
          </div>
          <div
            ref={contentRef}
            className={active ? `answer answer-divider text-[16px] 2xs:text-[20px]` : `answer text-[16px] 2xs:text-[20px] `}
          >
            <p>{props.content}</p>
          </div>
        </div>
      </button>
    </div>);
}
      
const FAQ = () => {
  return (
    <>
      <div id='faq' className='w-full bg-darkblue min-h-[90vh] pb-5'>

      <h1 className='text-white pt-10 pb-10 text-center font-sans md:text-6xl text-[10vw] font-bold'>FAQ</h1>

      {/* <Section
            title="Are there any ads in the app?"
            content="No, WE HATE ADS TOO and we do not show any ads in the app."
        /> */}
        
        <Section
            title="Will there be more updates in future?"
            content="Yes, the AutoJoomer team is currently working on new ideas such as getting contact details of faculties and other staff members in-app, mess food updates, marks tracker and many more. We aim to be providing frequent updates in the future."
        />

        <Section
            title="Can AutoJoomer team access my LMS?"
            content="No, the AutoJoomer team can't access your LMS since it stores the LMS's Password on the device and not on server. If you still have any doubts you can send your query by email at sumanth@autojoomer.co."
        />

        {/* Removed the pricing link( <a href='#pricing'>#Pricing</a>) as I need to figure out how to pass that effectively :skull: */}
        <Section
            title="What's the catch then?"
            content="There 's no catch at all. AutoJoomer team believes in providing value and we do so by keeping our product as productive as possible and simplify the life of students, with this we provide constant updates too(AutoJoomer extension has been actively receiving updates since October 2021). But you can still support this project by scanning the UPI QR code in the Pricing section(there might be some incremental costs to keep the project running, publishing on play store, database costs etc.)."
        />

        <Section
            title="Ok so, tell me how to get started quickly ??"
            content="Download the app by clicking on Download link on top right or bottom right. After you install the app and open it, you will see a 'Sign up here' link, click on it, make an account, put the credentials in the app and you are good to go! "
        />

        <Section
            title="How to reset the AutoJoomer password?"
            content="Currently we don't have auto password reset through recovery link or OTP, you can just send an email to admin@autojoomer.co and we will help you recover the account."
        />
      </div>
    </>
  )
}

export default FAQ;


